import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { HomeCarouselStyles } from '../home-carousel-styles/home-carousel-styles';
import { HomeCarouselSweater } from '../home-carousel-sweater/home-carousel-sweater';
@Component({
  selector: 'section[app-home-carousel]',
  imports: [HomeCarouselSweater, HomeCarouselStyles, MatIconModule],
  templateUrl: './home-carousel.html',
  styleUrl: './home-carousel.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class HomeCarousel {}
